//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_infinity = 5906376272000.0;\n\
";
